import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/estaOAquella/data/constants';

const initState = { currentScreen: SCREENS.PROGRESS, previousScreen: null };

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { currentScreen: payload, previousScreen: state.currentScreen };
    default:
      return state;
  }
};

export default screenReducer;
